<template>
  <div class="bg-grey-stripo">
    <PopUpPreview
      ref="previewPopup"
      :htmlContent="emailHtml"
      :isPdpa="pdpaEmail"
    ></PopUpPreview>

    <div :id="'stripo-' + name" class="stripo-container">Loading...</div>
    <div :id="'stripo-preview-' + name" class="stripo-preview"></div>
  </div>
</template>

<script>
import PopUpPreview from "../automation/component/PopUpPreviw.vue";
export default {
  components: {
    PopUpPreview,
  },
  mounted() {
    this.loadDemoTemplate(this.initPlugin);
  },
  // Utility methods
  props: {
    value: {
      required: false,
      type: String,
    },
    textFloat: {
      required: false,
      type: String,
    },
    placeholder: {
      required: false,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    pattern: {
      required: false,
      type: String,
    },
    detail: {
      required: false,
      type: String,
    },
    name: {
      required: false,
      type: String,
      default: "container",
    },
    isDisplay: {
      required: false,
      type: Boolean,
    },
    rows: {
      required: false,
      type: Number,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
    maxLength: {
      required: false,
      type: Number,
    },
    img: {
      required: false,
      type: String,
    },
    v: {
      required: false,
      type: Object,
    },
    variableItem: {
      required: false,
    },
    formMain: {
      required: false,
    },
    template: {
      required: false,
      type: Object,
      default() {
        return {
          html: "",
          css: "",
        };
      },
    },
    variableCampaignList: {
      required: false,
      default: () => [],
    },
    pdpaEmail: {
      required: false,
    },
  },
  data() {
    return {
      editor: null,
      file: "",
      type: {
        all: ["image/jpeg", "image/png", "video/mp4"],
        file: ["image/jpeg", "image/png", "application/pdf"],
        pdf: ["application/pdf"],
        png: ["image/png"],
        image: ["image/jpeg", "image/png"],
        video: ["video/mp4"],
        excel: [
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ],
      },
      error: "",
      hasError: false,
      hasImage: false,
      imgModal: null,
      msgModal: null,
      isSuccess: false,
      showPreview: false,
      emailHtml: "",
    };
  },
  methods: {
    save() {
      window.StripoApi.getTemplate(function (html, css) {});
    },
    openPreviewPopup() {
      window.StripoApi.compileEmail((error, html) => {
        if (!error) {
          this.emailHtml = html;
          this.$refs.previewPopup.openPopup();
        } else {
          console.error("Error compiling email for preview:", error);
        }
      }, true);
    },
    async compileEmail(flag = false) {
      if (!flag) this.$bus.$emit("showLoading");
      return new Promise((resolve, reject) => {
        const $ = this;

        return window.StripoApi.compileEmail(
          function (error, compile) {
            let compileHtml = compile;
            window.StripoApi.getTemplate(function (html, css) {
              let template = { html, css };
              $.$emit("onDataChange", { compileHtml, template });
              if (!flag) $.$bus.$emit("hideLoading");
              return resolve({ compileHtml, template });
            });
          },
          true,
          false
        );
      });
    },
    async loadDemoTemplate(callback) {
      const $ = this;
      if ($.template.html.trim() == "" && $.template.css.trim() == "")
        this.request(
          "GET",
          "https://raw.githubusercontent.com/ardas/stripo-plugin/master/Public-Templates/Basic-Templates/Empty-Template/Empty-Template.html",
          null,
          function (html) {
            $.request(
              "GET",
              "https://raw.githubusercontent.com/ardas/stripo-plugin/master/Public-Templates/Basic-Templates/Empty-Template/Empty-Template.css",
              null,
              function (css) {
                callback({
                  html: $.template.html.trim() == "" ? html : $.template.html,
                  css: $.template.css.trim() == "" ? css : $.template.css,
                });
              }
            );
          }
        );
      else
        callback({
          html: $.template.html,
          css: $.template.css,
        });
    },
    request(method, url, data, callback) {
      var req = new XMLHttpRequest();
      req.onreadystatechange = function () {
        if (req.readyState === 4 && req.status === 200) {
          callback(req.responseText);
        } else if (req.readyState === 4 && req.status !== 200) {
          console.error(
            "Can not complete request. Please check you entered a valid PLUGIN_ID and SECRET_KEY values"
          );
        }
      };
      req.open(method, url, true);
      if (method !== "GET") {
        req.setRequestHeader("content-type", "application/json");
      }
      req.send(data);
    },

    initPlugin(template) {
      const apiRequestData = {
        emailId: "6251361f166bfd9e51e19a03",
        userId: "600a68cbbbc06742e4453517",
        groupId: "test",
      };

      const script = document.createElement("script");
      script.id = "stripoScript";
      script.type = "text/javascript";
      script.src = "https://plugins.stripo.email/static/latest/stripo.js";
      var $ = this;
      console.log("stripo-" + $.name);
      const initStripo = (template) => {
        window.Stripo.init({
          settingsId: "stripo-" + $.name,
          previewId: "stripo-preview-" + $.name,

          locale: "en",
          html: template.html,
          css: template.css,
          apiRequestData: apiRequestData,
          userFullName: "Plugin Demo User",
          mergeTags: [
            {
              category: "Variables",
              entries: $.variableItem,
            },
            ...campaignTag,
            ...mergeTags,
          ],

          getAuthToken: function (callback) {
            $.request(
              "POST",
              "https://plugins.stripo.email/api/v1/auth",
              JSON.stringify({
                pluginId: process.env.VUE_APP_STRIPO_PLUGIN_ID,
                secretKey: process.env.VUE_APP_STRIPO_SECRET_KEY,
              }),
              function (data) {
                callback(JSON.parse(data).token);
              }
            );
          },
        });
        this.$emit("onInitFinish", true);
      };
      var campaignTag = [];
      let mergeTags = [];
      if ($.variableCampaignList.length > 0) {
        campaignTag.push({
          category: "Campaigns Field",
          entries: $.variableCampaignList
            .filter((el) => el.branch.length == 0)
            .map((el) => {
              function removeBraces(text) {
                return text?.replace(/[{}]/g, "");
              }
              return {
                label: el.display_name,
                value: `{{${removeBraces(el.name)}}}`,
              };
            }),
        });
        const hasBranch = $.variableCampaignList.filter(
          (el) => el.branch.length > 0
        );
        for (const element of hasBranch) {
          mergeTags.push({
            category: "Branch Field - " + element.display_name,
            entries: element.branch.map((el) => {
              return {
                label: el.display_name,
                value: `{{${el.name}}}`,
              };
            }),
          });
        }
      }
      if (window.Stripo) return initStripo(template);
      else {
        script.onload = function () {
          initStripo(template);
        };
        document.body.appendChild(script);
      }
    },
    clearField() {
      const $ = this;
      this.request(
        "GET",
        "https://raw.githubusercontent.com/ardas/stripo-plugin/master/Public-Templates/Basic-Templates/Empty-Template/Empty-Template.html",
        null,
        function (html) {
          $.request(
            "GET",
            "https://raw.githubusercontent.com/ardas/stripo-plugin/master/Public-Templates/Basic-Templates/Empty-Template/Empty-Template.css",
            null,
            async function (css) {
              await $.initPlugin({
                html: html,
                css: css,
              });
              $.compileEmail();
            }
          );
        }
      );
    },
  },
};
</script>

<style lang="scss">
.nav-tabs.nav-justified {
  display: block !important;
}
.stripo-container {
  width: 400px;
  float: left;
  height: 100% !important;
  max-height: 100% !important;
  overflow: auto;

  ::v-deep buttons-selector div.btn-group {
    // display: none !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-top: 1rem !important;
    float: left !important;
  }
  .esd-stripes-popover {
    top: 0 !important;
    min-height: max-content !important;
    margin-top: 0 !important;
  }
  ::v-deep .caret {
    display: none;
  }

  ::v-deep .upload-link {
    width: 300px;
  }

  ::v-deep .esdev-app .dropdown-menu-right {
    right: auto !important;
  }

  ::v-deep .esdev-t-upload-menu {
    width: 40px;
  }

  ::v-deep .esdev-library-thumbnails-container {
    overflow-y: auto !important;
  }

  ::v-deep .modules-category {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    height: 150px !important;
  }
  ::v-deep .esdev-item-name {
    max-height: unset !important;
    height: 20px !important;
  }
}

.stripo-preview {
  // width: auto;
  min-width: calc(100% - 400px);
  float: left;
}

::v-deep .esdev-preview-splitter {
  // height: auto !important;
}
</style>
